import { useState, type SyntheticEvent } from 'react';
import { Box, Paper, Typography, Tabs, Tab } from '@mui/material';
import RecordsTab from './RecordsTab';
import FoldersTab from './FoldersTab';

const DEFAULT_PAGE_LIMIT = 10;

export default function RecycleBin() {
  const [tab, setTab] = useState(0);
  const [orgId, setOrgId] = useState<string | undefined>(undefined);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(DEFAULT_PAGE_LIMIT);

  const handleTabChange = (_: SyntheticEvent, value: number) => {
    setTab(value);
    setPage(1);
  };

  const handlePageChange = (newPage: number, newLimit: number) => {
    setPage(newPage);
    setLimit(newLimit);
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} flexWrap="wrap" gap={1}>
        <Typography variant="h5" fontWeight={600}>
          Recycle Bin
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {tab === 0
            ? 'Items expire after 90 days'
            : 'Restores folder rows in the library; cloud files deleted with the folder may still be missing'}
        </Typography>
      </Box>

      <Tabs value={tab} onChange={handleTabChange} sx={{ mb: 2 }} aria-label="Recycle bin sections">
        <Tab label="Records" />
        <Tab label="Deleted folders" />
      </Tabs>

      <Paper
        elevation={2}
        sx={{
          p: 2,
          borderRadius: '12px',
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          width: '100%',
          minHeight: { xs: '500px', lg: 'calc(100vh - 280px)' },
        }}
      >
        {tab === 0 ? (
          <RecordsTab
            orgId={orgId}
            page={page}
            limit={limit}
            onPageChange={handlePageChange}
            onOrgIdChange={setOrgId}
          />
        ) : (
          <FoldersTab
            orgId={orgId}
            page={page}
            limit={limit}
            onPageChange={handlePageChange}
            onOrgIdChange={setOrgId}
          />
        )}
      </Paper>
    </Box>
  );
}
